module.exports = new __parcel__URL__("valid-icon.e926ba23.svg").toString();